<template>
  <div v-if="display" class="ak-bulk-actions" :class="bulkActionClasses">
    <div class="ak-bulk-actions--header color-white">
      <slot name="head" />
      <ak-button
        v-if="allowToggle"
        color="transparent"
        circle
        size="small"
        single-icon
        @click.stop.prevent="showBody = !showBody"
      >
        <ak-icon v-if="showBody" type="chevron-down" color="white" />
        <ak-icon v-if="!showBody" type="chevron-up" color="white" />
      </ak-button>
    </div>
    <div class="ak-bulk-actions--body" :class="bulkActionBodyClasses">
      <div class="p-small text-nowrap">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import Button from '../button/Button.vue'
import Icon from '../icon/Icon.vue'
export default defineComponent({
  name: 'AkBulkActions',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  props: {
    display: {
      type: Boolean,
      default: false,
    },
    allowToggle: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: 'right',
      validator: (v) => ['left', 'right'].includes(v),
    },
    fixed: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const showBody = ref(true)
    const bulkActionClasses = computed(() => {
      return {
        [`ak-bulk-actions--${props.position}`]: true,
        ['fixed']: props.fixed,
        ['absolute']: !props.fixed,
      }
    })
    const displayBody = computed(() => {
      if (!props.allowToggle) return true
      return showBody.value
    })

    const bulkActionBodyClasses = computed(() => {
      return {
        'ak-bulk-actions--body-collapse': !displayBody.value,
      }
    })
    return {
      bulkActionClasses,
      showBody,
      displayBody,
      bulkActionBodyClasses,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-bulk-actions {
  bottom: 0;
  box-shadow: $base-shadow;
  border-top-left-radius: $base-border-radius;
  border-top-right-radius: $base-border-radius;
  z-index: 99;
  &--header {
    border-top-left-radius: $base-border-radius;
    border-top-right-radius: $base-border-radius;
    background-color: $color-primary;
    line-height: $base-line-height;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $spacing-tiny $spacing-small;
  }
  &--left {
    left: 0;
    margin-left: $spacing;
  }
  &--right {
    right: 0;
    margin-right: $spacing;
  }
  &--body {
    background-color: #fff;
    overflow: hidden;
    max-height: calc(100vh - 50px);
    transition: max-height 0.5s ease-in-out;
  }
  &--body-collapse {
    max-height: 0px;
  }
}
</style>
